import React, { useEffect, useState } from "react";
import { Popover } from "@mui/material";
import StyledButton from "../../../../Reuse/UI/StyledButton";
import { FilterIcon } from "../../../../Reuse/Icon";
import FilterForm from "./FilterForm";
import { useSearchParams } from "react-router";
import { decodeParamsToValues } from "../../../../utils/queryParams";
import { removeEmptyKeys } from "../../../../utils/removeEmptyKeys";

const Filter = ({ defaultFilter }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchParams] = useSearchParams();
  const [isFiltered, setIsFiltered] = useState(false);

  useEffect(() => {
    const paramData = decodeParamsToValues(searchParams, defaultFilter.filter(({ showInFilter }) => showInFilter));
    const filteredParams = removeEmptyKeys(paramData);

    if (Object.keys(filteredParams).length > 0) {
      if (Object.keys(filteredParams).length === 1) {
        if (filteredParams.hasOwnProperty("sort_by") && filteredParams.sort_by === "Campus ID") {
          setIsFiltered(false);
        } else {
          setIsFiltered(true);
        }
      } else {
        setIsFiltered(true);
      }
    } else {
      setIsFiltered(false);
    }
  }, [searchParams, defaultFilter, setIsFiltered]);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const open = Boolean(anchorEl);
  const id = open ? "filter-popover" : undefined;

  return (
    <>
      <StyledButton
        variant={isFiltered ? "contained" : "outlined"}
        onClick={handleClick}
        aria-describedby={id}
        startIcon={<FilterIcon sx={{ color: "inherit" }} />}
        sx={{
          ["& .MuiButton-startIcon"]: {
            marginLeft: 0,
          },
        }}
      >
        Filter
      </StyledButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        sx={{
          '& .MuiPaper-root': {
            width: 437,
            border: "1px solid #101828",
            borderRadius: 1.5,
            padding: 1.5,
            background: "#FFFFFF",
            overflow: "auto",
            marginTop: 1,
          },
        }}
      >
        <FilterForm defaultFilter={defaultFilter} handleClose={handleClose} />
      </Popover>
    </>
  );
};

export default Filter;
